
import { Component, Vue} from 'vue-property-decorator';
import moment from 'moment-timezone';

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import { stepInfoType } from '@/types/Application';

@Component
export default class NavigationSidebar extends Vue {
    
    @applicationState.State
    public currentStep!: Number;

    @applicationState.State
    public id!: string;

    @applicationState.State
    public steps!: stepInfoType[];
    
    @applicationState.State
    public allCompleted!: Boolean;

    @applicationState.Action
    public UpdateCurrentStep!: (newCurrentStep) => void

    @applicationState.Action
    public UpdateCurrentStepPage!: (newCurrentStepPage) => void

    @applicationState.Action
    public UpdateLastUpdated!: (newLastUpdated) => void


    error = "";
    updateSidebar = 0;   

    public onSelectStep(event) {
      
        const next = event.currentTarget;
        const nextIndex = parseInt(next.getAttribute("index"));     
        
        this.UpdateCurrentStep(nextIndex);      
        Vue.nextTick().then(()=>{Vue.prototype.$saveChanges();});
    }
   
    public onSelectPage(event) {
        const currStepIndex = this.$store.state.Application.currentStep;
       
        const nextPage = event.currentTarget;
        const nextPageIndex = parseInt(nextPage.getAttribute("index"));

        if(this.steps[currStepIndex].pages[nextPageIndex].progress == 0) return

        this.UpdateCurrentStepPage({currentStep: currStepIndex, currentPage: nextPageIndex });
        Vue.nextTick().then(()=>{Vue.prototype.$saveChanges();});
    }

    public getNavigation() {        
        return this.steps;
    }

    public getStepDisplayNumber(stepIndex) {
        const steps = this.getNavigation();
        let stepDisplayNumber = stepIndex + 1;  // convert 0-based index number to 1-based display number

        for (let i = stepIndex - 1; i >= 0; i--) {
            if (!steps[i].active) {
            // adjust display number
            stepDisplayNumber--;
            }
        }

        return stepDisplayNumber;
    }

    public isCurrentStep(stepIndex) {
        return this.currentStep == stepIndex;
    }

    public isAllCompleted() {
        return this.allCompleted;
    }

    public getStepId(stepIndex) {
        return "step-" + stepIndex;
    }

    public getStepGroupId(stepIndex) {
        return this.getStepId(stepIndex) + "-group";
    }

    public getStepPageId(stepIndex, pageIndex) {
        return this.getStepId(stepIndex) + "-page-" + pageIndex;
    }
    
    public isStepTouched(nextStepIndex){
        const selectedStep = this.steps[nextStepIndex];
        for(const page of selectedStep.pages){
            
            if(page.progress > 0) return true;
        }
        return false
    }

    public getPageProgress(stepIndex, pageIndex){
        return this.steps[stepIndex].pages[pageIndex].progress
    }

};
